import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login02, logo, lines, logoCuidado} from "../../imagepath";
import { css } from "@emotion/react";
import { ScaleLoader } from "react-spinners";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useState } from "react";
import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";
import { useAuth } from "../../../context/AuthContext";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const Login = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [pinVisible, setPinVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [pin, setPin] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password || !pin) {
      setErrorMessage("Por favor, completa todos los campos.");
      return;
    }

    try {
      setLoading(true);
      const response = await login(username, password, pin);
      if (response && response.ok === true) {
        navigate("/admin");
      } else {
        console.error(response);
        setErrorMessage(response.mensaje || "Error durante inicio de sesion");
      }
    } catch (error) {
      console.error("Error durante inicio de sesion in:", error);
      setErrorMessage("Error durante inicio de sesion");
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const togglePinVisibility = () => {
    setPinVisible(!pinVisible);
  };

  return (
    <>
      {loading && (
        <div className="overlay-loading">
          <ScaleLoader
            css={override}
            size={150}
            color={"#4e57cd"}
            loading={loading}
          />
        </div>
      )}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            <div className="login-sec"></div>
            <div className="col-lg-6 ">
              <div className="log-img"></div>
            </div>
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="logoHumano">
                        <Link to="/admin">
                          <img src={logo} alt="#" width={200} />
                        </Link>
                      </div>
                      <div className="logoCuidado">
                        <Link to="/login">
                          <img src={logoCuidado} alt="#" width={160} />
                        </Link>
                      </div>
                      <div className="titles">
                        <label className="title">Inicio de sesión </label>
                        <label className="label-description  mb-5">
                          Favor ingresar sus datos de acceso{" "}
                        </label>
                      </div>
                      {!loading && errorMessage && (
                        <div className="text-center text-danger mb-3">
                          {errorMessage}
                        </div>
                      )}
                      <form onSubmit={handleLogin}>
                        <div className="form-group">
                          <label for="inputUsername">
                            Usuario <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="inputUsername"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Contraseña <span className="login-danger">***</span>
                          </label>
                          <div className="d-flex align-items-center">
                            <input
                              type={passwordVisible ? "text" : "password"}
                              className="form-control pass-input flex-grow-1"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                              className="toggle-password ml-2"
                              onClick={togglePasswordVisibility}
                            >
                              {passwordVisible ? (
                                <EyeOff className="react-feather-custom" />
                              ) : (
                                <Eye className="react-feather-custom" />
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>
                            Pin <span className="login-danger">*</span>
                          </label>
                          <div className="d-flex align-items-center">
                            <input
                              type={pinVisible ? "text" : "password"}
                              className="form-control pass-input flex-grow-1"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={pin}
                              onChange={(e) => setPin(e.target.value)}
                            />
                            <span
                              className="toggle-password ml-2"
                              onClick={togglePinVisibility}
                            >
                              {pinVisible ? (
                                <EyeOff className="react-feather-custom" />
                              ) : (
                                <Eye className="react-feather-custom" />
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="forgotpass">
                          <Link to="/restablecer-pin">Olvidé mi pin</Link>
                        </div>
                        <div className="form-group login-btn">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                          >
                            Acceder
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <img className="login-lines" src={lines} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
